// import { create } from "zustand";

// const useNewsFeedStore = create((set) => ({
//     isNewsPageLoaded: false,
//     isNewsFeedApiLoading: false,

//     updateIsNewsPageLoaded: (flag) =>
//         set((state) => ({
//             ...state,
//             isNewsPageLoaded: flag,
//         })),

//     setIsNewsFeedApiLoading: (flag) =>
//         set((state) => {
//             console.log("setIsNewsFeedApiLoading:", flag);
//             return {
//                 ...state,
//                 isNewsFeedApiLoading: flag,
//             };
//         }),
// }));

// export default useNewsFeedStore;

import { create } from "zustand";

const useNewsFeedStore = create((set) => ({
  isNewsPageLoaded: false,
  isNewsFeedApiLoading: false,

  // new name
  setIsNewsPageLoaded: (flag) =>
    set((state) => ({
      ...state,
      isNewsPageLoaded: flag,
    })),

  //  old code
  updateIsNewsPageLoaded: (flag) =>
    set((state) => ({
      ...state,
      isNewsPageLoaded: flag,
    })),

  setIsNewsFeedApiLoading: (flag) =>
    set((state) => {
      console.log("setIsNewsFeedApiLoading:", flag);
      return {
        ...state,
        isNewsFeedApiLoading: flag,
      };
    }),
}));

export default useNewsFeedStore;


